import { useState } from 'react';

interface FAQItem {
  q: string;
  a: string;
}

const faqData: FAQItem[] = [
  {
    q: '努努影院是否需要注册才能观看？',
    a: '不需要注册。努努影院所有电视剧资源均免费提供，无需注册账号即可直接在线观看，方便快捷，即点即看。',
  },
  {
    q: '为什么努努影院播放不缓冲？',
    a: '努努影院采用了先进的CDN加速技术和多线服务器部署，确保视频加载速度快、播放流畅。同时我们持续优化播放器性能，为您提供最佳观看体验。',
  },
  {
    q: '努努影院支持哪些设备观看？',
    a: '努努影院全面支持电脑、平板、手机等多种设备。无论您使用Windows、Mac、iOS还是Android系统，都可以流畅观看高清电视剧。',
  },
  {
    q: '电视剧更新频率是怎样的？',
    a: '我们与各大视频平台保持同步更新，最新剧集上线后第一时间更新。热门电视剧通常在播出后数小时内即可在努努影院观看。',
  },
  {
    q: '努努影院提供哪些类型的电视剧？',
    a: '努努影院提供国产剧、韩剧、美剧、日剧、泰剧、动漫等多类型电视剧资源，涵盖悬疑、爱情、古装、科幻、喜剧等各种题材，满足不同观众的追剧需求。',
  },
  {
    q: '观看时出现卡顿怎么办？',
    a: '如遇播放卡顿，建议您尝试切换清晰度或刷新页面。也可以检查自己的网络连接。如问题持续，请联系我们的在线客服获取帮助。',
  },
];

export default function FAQSection() {
  const [openIdx, setOpenIdx] = useState<number | null>(null);

  return (
    <section className="px-4 md:px-6 py-10 md:py-14 bg-background-100">
      <div className="max-w-3xl mx-auto">
        <div className="text-center mb-8 md:mb-10">
          <div className="w-10 h-10 flex items-center justify-center mx-auto mb-3">
            <i className="ri-question-answer-line text-2xl text-primary-500"></i>
          </div>
          <h2 className="font-heading text-lg md:text-xl font-bold text-foreground-900 mb-2">
            常见问题
          </h2>
          <p className="text-sm text-foreground-500">
            关于努努影院的常见疑问，这里都有答案
          </p>
        </div>
        <div className="space-y-3">
          {faqData.map((item, idx) => (
            <div
              key={idx}
              className="bg-background-50 rounded-xl overflow-hidden border border-background-200/70"
            >
              <button
                className="w-full flex items-center justify-between px-5 py-4 text-left cursor-pointer"
                onClick={() => setOpenIdx(openIdx === idx ? null : idx)}
              >
                <span className="font-medium text-sm text-foreground-800 pr-4">
                  {item.q}
                </span>
                <div className={`w-6 h-6 flex items-center justify-center flex-shrink-0 transition-transform duration-300 ${openIdx === idx ? 'rotate-45' : ''}`}>
                  <i className="ri-add-line text-foreground-500"></i>
                </div>
              </button>
              {openIdx === idx && (
                <div className="px-5 pb-4 text-sm text-foreground-600 leading-relaxed">
                  {item.a}
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}